import { styled } from "styled-components";

export const EditTournamentDropBox = styled.div`
  width: 290px;
  height: 24px;
  border-radius: 2.7px;
  padding: 5px 8px;
  border: 0.67px solid var(--Black-200, #b7b7b7);
  background: var(--Black-100, #f0f0f0);
  cursor: pointer;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 10.79px;
  color: #121212;
  line-height: 18px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const EditTournamentDropBoxItemWrapper = styled.div`
  width: 100%;
  border-radius: 2.7px;
  border: 1px solid #b7b7b7;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 1000;
  background: #fff;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 10.79px;
  color: #121212;
  top: 38px;
  left: 0;
`;

export const EditTournamentDropBoxItem = styled.div<{ selected: boolean }>`
  height: 28px;
  padding: 0 8px;
  box-sizing: border-box;
  font-family: Pretendard;
  font-weight: 500;
  font-size: 10.79px;
  line-height: 28px;
  color: ${(p) => (p.selected ? "#121212" : "#B7B7B7")};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
